module.exports = __webpack_public_path__ + "img/login_header_title.839494e1.jpg";